import LoginAction from "@common/redux/actions/LoginAction";
import { useSelector } from "react-redux";

function useLogin() {
  return [
    useSelector((state) => LoginAction.getStatePath(state)),
    LoginAction.dispatch,
  ];
}

export default useLogin;
